// Single source of truth for the SyQi ORDER-section tool roster.
// Imported by the mobile dashboard (orderSections.ts) AND by the Next.js
// backend (src/app/api/ai/overview/route.ts) — keep this file pure TS with
// no React/React Native/supabase imports so both bundlers can consume it.
import type { Gear } from '../domain/olmps';

export type { Gear } from '../domain/olmps';
export { GEARS, TOOL_NAMES } from '../domain/olmps';

// Which tools belong to (and can be toggled on in) each section. Only tools
// with native implementations in ToolHost. A tool may live in two sections
// (CLIO: morning entry in Orient, journal close in Revise — per the ORDER
// expanded mock).
// Direct/Execute: JNUS (the criteria-based decision tool, DMT id JANUS) moved
// Direct → Execute per the new-system conformance spec.
export const SECTION_TOOLS: Record<Gear, string[]> = {
  orient: ['oracle', 'telos', 'astrs', 'clio', 'sofia'],
  regulate: ['numa', 'moyri', 'argos', 'akeso', 'hrmez'],
  direct: ['kyrs', 'krnos', 'tkne'],
  execute: ['metis', 'themis', 'jnus', 'epic'],
  revise: ['clio', 'oracle', 'nemos'],
};

// Default-on tools per section — the season-1 starting five
// (ORACLE / NUMA / KYRS / METIS / CLIO) plus ASTRS, KRNOS and TKNE. Every tool
// can be toggled on from day one; nothing is locked.
export const SECTION_DEFAULTS: Record<Gear, string[]> = {
  orient: ['oracle', 'astrs'],
  regulate: ['numa'],
  direct: ['kyrs', 'krnos', 'tkne'],
  execute: ['metis'],
  revise: ['clio'],
};

/** Per-section enabled tool ids. Absent key = use SECTION_DEFAULTS. */
export type SyqiSections = Partial<Record<Gear, string[]>>;

/** Enabled tools for a section, sanitized against SECTION_TOOLS order. */
export function enabledToolsFor(sections: SyqiSections | null | undefined, gear: Gear): string[] {
  const chosen = sections?.[gear] ?? SECTION_DEFAULTS[gear];
  return SECTION_TOOLS[gear].filter((id) => chosen.includes(id));
}
